// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
import ElementUI from 'element-ui'
import global from '@/utils/global'
import 'element-ui/lib/theme-chalk/index.css'
import prototype from '@/utils/prototype' // 挂载在原型上的方法
import store from './store/index'
import VCharts from 'v-charts' // 导入v-char
import Print from '@/utils/print'

Vue.config.productionTip = false
Vue.use(ElementUI)
ElementUI.Dialog.props.closeOnClickModal.default = false // 点击遮罩层禁止关闭弹窗
Vue.use(prototype)
Vue.use(VCharts)
Vue.use(Print)

/*
* axios设置
* */
axios.defaults.baseURL = global.httpBaseURL
// 请求超时时限 我设置500毫秒
axios.defaults.timeout = 180000
// 请求的间隙
axios.defaults.retryDelay = 1000

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
  // VueAMap
})



// WEBPACK FOOTER //
// ./src/main.js